import { useState } from "react"
import {
    flexRender,
    getCoreRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable
} from "@tanstack/react-table"
import FirstIcon from '../assets/svg/chevrons-left.svg?react'
import PreviousIcon from '../assets/svg/chevron-left.svg?react'
import NextIcon from '../assets/svg/chevron-right.svg?react'
import LastIcon from '../assets/svg/chevrons-right.svg?react'

export default function CustomTable({ data, columns, classlist, defaultSortColumn, perPage = 10, sortByDesc = true }) {
    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: perPage })
    const [sorting, setSorting] = useState([{ id: defaultSortColumn, desc: sortByDesc }])

    const table = useReactTable({
        columns: columns,
        data: data,
        debugTable: false,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        enableSorting: true,
        state: {
            pagination,
            sorting
        }
    })

    return (
        <>
            <table className={classlist} style={{ border: '1px solid var(--color-line)' }}>
                <thead>
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id} style={{ borderBottom: '1px solid var(--color-line)' }}>
                            {headerGroup.headers.map(header => {
                                return (
                                    <th key={header.id} colSpan={header.colSpan}>
                                        <div className={`header-cell ${header.column.getIsSorted() ? (header.column.getIsSorted() === 'asc' ? 'sort-asc' : 'sort-desc') : ''}`}
                                            onClick={header.column.getToggleSortingHandler()}
                                            title={
                                                header.column.getCanSort()
                                                    ? header.column.getIsSorted() === 'asc'
                                                        ? 'Sort ascending'
                                                        : header.column.getIsSorted() === 'desc'
                                                            ? 'Sort descending'
                                                            : 'Clear sort'
                                                    : undefined
                                            }
                                        >
                                            {flexRender(header.column.columnDef.header, header.getContext())}
                                        </div>
                                    </th>
                                )
                            })}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {table.getRowModel().rows.map(row => {
                        return (
                            <tr key={row.id} style={{ borderBottom: '1px solid var(--color-line)' }}>
                                {row.getVisibleCells().map(cell => {
                                    return (
                                        <td key={cell.id}>
                                            {flexRender(
                                                cell.column.columnDef.cell,
                                                cell.getContext()
                                            )}
                                        </td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {pagination.pageSize < data.length && (
                <div className="flex flex-col items-center gap-4 pt-2 md:flex-row md:justify-between">
                    <div>
                        Showing {table.getRowModel().rows.length.toLocaleString()} of{' '}
                        {table.getRowCount().toLocaleString()} Rows
                    </div>
                    <div className="flex gap-2">
                        <button
                            className="bg-transparent text-blue-600 dark:text-blue-400 border border-blue-600 dark:border-blue-400 p-2 cursor-pointer disabled:bg-base-500 dark:disabled:bg-base-dark-500 disabled:border-base-400 dark:disabled:border-base-dark-400 disabled:text-base-content dark:disabled:text-base-dark-content disabled:cursor-not-allowed"
                            onClick={() => table.firstPage()}
                            disabled={!table.getCanPreviousPage()}
                        ><FirstIcon width={14} height={14} /></button>
                        <button
                            className="bg-transparent text-blue-600 dark:text-blue-400 border border-blue-600 dark:border-blue-400 p-2 cursor-pointer disabled:bg-base-500 dark:disabled:bg-base-dark-500 disabled:border-base-400 dark:disabled:border-base-dark-400 disabled:text-base-content dark:disabled:text-base-dark-content disabled:cursor-not-allowed"
                            onClick={() => table.previousPage()}
                            disabled={!table.getCanPreviousPage()}
                        ><PreviousIcon width={14} height={14} /></button>
                        <span className="flex items-center gap-1">
                            <div>Page</div>
                            <strong>
                                {table.getState().pagination.pageIndex + 1} of{' '}
                                {table.getPageCount().toLocaleString()}
                            </strong>
                        </span>
                        <button
                            className="bg-transparent text-blue-600 dark:text-blue-400 border border-blue-600 dark:border-blue-400 p-2 cursor-pointer disabled:bg-base-500 dark:disabled:bg-base-dark-500 disabled:border-base-400 dark:disabled:border-base-dark-400 disabled:text-base-content dark:disabled:text-base-dark-content disabled:cursor-not-allowed"
                            onClick={() => table.nextPage()}
                            disabled={!table.getCanNextPage()}
                        ><NextIcon width={14} height={14} /></button>
                        <button
                            className="bg-transparent text-blue-600 dark:text-blue-400 border border-blue-600 dark:border-blue-400 p-2 cursor-pointer disabled:bg-base-500 dark:disabled:bg-base-dark-500 disabled:border-base-400 dark:disabled:border-base-dark-400 disabled:text-base-content dark:disabled:text-base-dark-content disabled:cursor-not-allowed"
                            onClick={() => table.lastPage()}
                            disabled={!table.getCanNextPage()}
                        ><LastIcon width={14} height={14} /></button>
                    </div>
                </div>
            )}
        </>
    )
}
